import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { OrchestrationResponse, RoutingStatusResponse } from '../models/report-response';
import { Observable } from 'rxjs';
import { AgentRequest, DocumentRequest } from '../models/agent-models/agent-request';
import { API_ENDPOINTS, buildEndpoint } from '../api-endpoint';
import { RuntimeConfigService } from '../config/runtime-config.service';

@Injectable({
  providedIn: 'root',
})
export class AgentService {
  private baseApiUrl: string;
  private apiVersion: string;
  constructor(private runtimeConfigService: RuntimeConfigService, private http: HttpClient) {
    this.baseApiUrl = this.runtimeConfigService.apiUrl;
    this.apiVersion = this.runtimeConfigService.apiVersion;
  }

  getApiUrl(apiEndpoint: string): string {
    return buildEndpoint(this.baseApiUrl, this.apiVersion, 'reportagent', apiEndpoint);
  }

  invokeOrchestrationAgent(request: AgentRequest): Observable<OrchestrationResponse> {
    return this.http.post<OrchestrationResponse>(
      this.getApiUrl(API_ENDPOINTS.AGENT_SERVICE.StartOrchestration),
      request
    );
  }

  getReportGenerationStatus(reportId: number): Observable<RoutingStatusResponse> {
    const apiUrl = this.getApiUrl(API_ENDPOINTS.AGENT_SERVICE.GetOrchestrationStatus).replace(
      '{reportId}',
      reportId.toString()
    );
    return this.http.get<RoutingStatusResponse>(apiUrl);
  }

  getDocument(request: DocumentRequest) {
    return this.http.post<Blob>(
      this.getApiUrl(API_ENDPOINTS.AGENT_SERVICE.DownloadReport),
      request,
      {
        responseType: 'blob' as 'json',
      }
    );
  }
}
